import { render, staticRenderFns } from "./BottomRight.vue?vue&type=template&id=7ed307b8&scoped=true"
import script from "./BottomRight.vue?vue&type=script&lang=js"
export * from "./BottomRight.vue?vue&type=script&lang=js"
import style0 from "./BottomRight.vue?vue&type=style&index=0&id=7ed307b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed307b8",
  null
  
)

export default component.exports